import { Colors } from '../../utils/resources/colors';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../toolkit/uicomponentcss';

export interface MainWrapperCSSStyle extends UIComponentCSSStyle
{
    getMainWrapperCSSStyle():object;

    getLogoWrapperCSSStyle():object;
    getMobileMainWrapperCSSStyle():object;
    getContentDivCSSStyle(): object;
}

export class MainWrapperCSSStyleImpl extends UIComponentCSSStyleImpl implements MainWrapperCSSStyle
{   

    getMainWrapperCSSStyle():object
    {
        return{
            // width:'100%',height:'auto',
            // height: "120px",
            display:"flex",
             position:"fixed",
             width:'100%',
             zIndex:"100",
             backgroundColor:this.getResources().getColor(Colors.color_5),
            borderBottom: "1px solid " + this.getResources().getColor(Colors.color_3),
        };
    }
    getMobileMainWrapperCSSStyle():object
    {
        return{
            // width:'100%',height:'60px',
            // height: "120px",
            display:"flex",
             position:"fixed",
             zIndex:"100",
            //  boxShadow:"0px 20px 20px 0px rgb(0 0 0 / 7%)",
             backgroundColor:this.getResources().getColor(Colors.color_5),
            borderBottom: "1px solid " + this.getResources().getColor(Colors.color_3),
        };
    }
    getLogoWrapperCSSStyle():object
    {
        return{
            height:'100%',justifyContent:'flex-start',marginLeft:"10px"
            // borderBottom: "1px solid " + this.getResources().getColor(Colors.color_3),

        };
    }
    getContentDivCSSStyle(): object
    {
        return {
            display: "flex",
         
            justifyContents: "center",
            flexFlow: "row wrap",
            
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/mainwrappercss.tsx